exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-border[data-v-ff1fa852]{border-radius:.5rem;background:#f44336;text-transform:capitalize!important;border-color:#ccc!important}.center_btns[data-v-ff1fa852]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:space-evenly;-ms-flex-pack:space-evenly;justify-content:space-evenly}button[data-v-ff1fa852]{text-transform:inherit}", ""]);

// exports
